import { RouterProvider } from 'react-router-dom';
import { Suspense } from 'react';
import useAuthenticatedUser from '@blueshift-ui/auth/dist/hooks/use-authenticated-user';
import useCreateRouter from './hooks/use-create-router';
import useIsVt4sClient from '../hooks/use-is-vt4s-client';

function AppRouter() {
  const { data: authenticatedUser, isLoading: isLoadingAuthenticatedUser } = useAuthenticatedUser();
  const { hasAccess: isVt4sClient } = useIsVt4sClient();
  const router = useCreateRouter(authenticatedUser, isVt4sClient);

  if (isLoadingAuthenticatedUser) {
    return null;
  }

  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default AppRouter;
